import { DEFAULT_FILTERS_VALUES } from '../helpersMyCasa/constants';

/**
 * Function to reset a temporary filter and trigger the update of the filters
 */

const resetTempFilter = ({
  filterName,
  filtersList,
  setFiltersList,
  filters,
  updateFilters,
  forceMobileUpdate,
}) => {
  const newFiltersList = [...filtersList].filter(
    (flt) => flt.name !== filterName,
  );
  setFiltersList(newFiltersList);

  const range = [
    'price',
    'mqprice',
    'payment',
    'numRooms',
    'mq',
    'buildingYear',
  ];

  const resetObj = range.includes(filterName)
    ? {
      [`${filterName}Min`]: DEFAULT_FILTERS_VALUES[`${filterName}Min`],
      [`${filterName}Max`]: DEFAULT_FILTERS_VALUES[`${filterName}Max`],
    }
    : {
      [filterName]: DEFAULT_FILTERS_VALUES[filterName],
    };
  updateFilters({ ...filters, ...resetObj }, forceMobileUpdate);
};

export default resetTempFilter;
